export const environment = {
    production: false,
    baseURL: 'https://uatapi.evoryn.in/',
    inspectOn: true,
    SINGLE_PRODUCT_BASE_URL: 'https://uat.evoryn.in/product/',
    COMBO_PRODUCT_BASE_URL: 'https://uat.evoryn.in/combo/',
};